import { render } from "./medicineResp.vue?vue&type=template&id=39a9862f&scoped=true"
import script from "./medicineResp.vue?vue&type=script&lang=js"
export * from "./medicineResp.vue?vue&type=script&lang=js"

import "./medicineResp.vue?vue&type=style&index=0&id=39a9862f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39a9862f"]])

export default __exports__